import { forwardRef, type Ref, type SVGProps } from "react";
const IconTeaFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M17.462 18.44c.143 0 .258.113.259.25v1.424c0 .138-.117.25-.26.25h-1.48a.255.255 0 0 1-.26-.25v-1.428c0-.138.117-.25.26-.25z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M22.5 8.85c.133 0 .26.052.354.142s.145.212.146.339v3.362l.249.006a5.1 5.1 0 0 1 3.286 1.402A4.72 4.72 0 0 1 28 17.5a4.72 4.72 0 0 1-1.465 3.4A5.1 5.1 0 0 1 23 22.306v3.847a3.78 3.78 0 0 1-1.173 2.718A4.1 4.1 0 0 1 19 30H8c-.525 0-1.046-.1-1.53-.293a4 4 0 0 1-1.299-.833 3.8 3.8 0 0 1-.866-1.248A3.7 3.7 0 0 1 4 26.154V9.331a.46.46 0 0 1 .145-.341.5.5 0 0 1 .355-.14zm-6.831 7.606h-1.496a.5.5 0 0 0-.356.139.47.47 0 0 0-.144.341v4.808c0 .127.053.249.146.339.094.09.221.14.354.141h4.999a.52.52 0 0 0 .351-.143.48.48 0 0 0 .15-.337v-4.808a.48.48 0 0 0-.148-.34.5.5 0 0 0-.353-.14h-1.503v-5.77h-2zm7.33 3.928a3.1 3.1 0 0 0 1.15-.22 3 3 0 0 0 .973-.624c.278-.268.499-.586.65-.936a2.8 2.8 0 0 0 0-2.208 2.9 2.9 0 0 0-.65-.935 3 3 0 0 0-.973-.625 3.1 3.1 0 0 0-1.15-.22z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M8.212 2.119a.85.85 0 0 1 .623-.098.82.82 0 0 1 .512.354.77.77 0 0 1 .102.598.8.8 0 0 1-.368.493l-.224.134a.25.25 0 0 0-.087.087.237.237 0 0 0 .08.324c.232.15.426.345.57.575a1.77 1.77 0 0 1 .172 1.543c-.09.253-.238.485-.432.677l-.506.502a.83.83 0 0 1-.59.238.85.85 0 0 1-.456-.131.8.8 0 0 1-.305-.353.77.77 0 0 1 .17-.863l.503-.498a.24.24 0 0 0 .06-.09.2.2 0 0 0 .011-.106.24.24 0 0 0-.111-.178c-.265-.17-.481-.4-.629-.671a1.78 1.78 0 0 1 .03-1.751c.156-.266.38-.49.65-.652z"
    />
    <path
      fill="currentColor"
      d="M13.154 2.119a.85.85 0 0 1 .623-.098.82.82 0 0 1 .512.354.77.77 0 0 1 .102.598.8.8 0 0 1-.367.493l-.226.134a.24.24 0 0 0-.006.411c.232.15.427.345.57.575a1.78 1.78 0 0 1 .172 1.543c-.09.253-.238.485-.432.677l-.506.502a.83.83 0 0 1-.59.238.85.85 0 0 1-.456-.131.8.8 0 0 1-.305-.353.77.77 0 0 1 .17-.863l.504-.498a.24.24 0 0 0 .07-.196.25.25 0 0 0-.112-.178 1.86 1.86 0 0 1-.628-.671 1.78 1.78 0 0 1 .03-1.751c.156-.266.38-.49.65-.652z"
    />
    <path
      fill="currentColor"
      d="M17.961 2.122a.85.85 0 0 1 .623-.099.82.82 0 0 1 .512.354.77.77 0 0 1 .102.598.8.8 0 0 1-.367.493l-.227.134a.25.25 0 0 0-.086.088.24.24 0 0 0 .081.323c.232.15.427.345.572.575a1.77 1.77 0 0 1 .171 1.544 1.8 1.8 0 0 1-.434.677l-.504.498a.83.83 0 0 1-.592.239.85.85 0 0 1-.457-.131.8.8 0 0 1-.306-.353.76.76 0 0 1-.05-.456.8.8 0 0 1 .22-.407l.505-.498a.24.24 0 0 0 .073-.193.25.25 0 0 0-.112-.178 1.86 1.86 0 0 1-.629-.672 1.77 1.77 0 0 1 .03-1.751c.157-.266.38-.49.65-.651z"
    />
  </svg>
);
const ForwardRef = forwardRef(IconTeaFilledSVG);
ForwardRef.displayName = "IconTeaFilled";
export { ForwardRef as IconTeaFilled };
